/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Date_FromInputs */

const vi_tea_purchase_date_from = /** @type {(inputs: Tea_Purchase_Date_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày cân (từ)`)
};

/**

* @param {Tea_Purchase_Date_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_date_from = /** @type {((inputs?: Tea_Purchase_Date_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Date_FromInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_date_from(inputs)
});